// ES5 format so it can be used by gatsby-node
module.exports = function normalizeUrlHelper(tag) {
    return tag.toLowerCase()
              .normalize("NFD").replace(/\p{Diacritic}/gu, "")  // Remove all diacritics (accents and such)
              .replace(/[^a-zA-Z0-9 -]/g, "")                   // Remove all special characters (keep spaces and -)
              .replace(/\s/g, "-");                             // Replace all spaces by "-"
};
